import { z } from 'zod'

const calendarDateSchema = z.iso.date()

export const asCalendarDate = (value: unknown): string | null => {
  const result = calendarDateSchema.safeParse(value)
  return result.success ? result.data : null
}
